// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"DownloadAppGroup_linkContainer__4Jaip","imageLink":"DownloadAppGroup_imageLink__f0h1p"};